import { useEffect, useState } from "react";
import api from "../lib/api";
import BranchPicker from "../components/BranchPicker";
import { useAuth } from "../context/AuthContext";
import { Trophy, Building2 } from "lucide-react";

export default function Leaderboard() {
  const { user } = useAuth();
  const isKec = user.role === "sales";
  const showBranchBoard = ["sm", "zh", "vp", "md", "admin"].includes(user.role);
  const [data, setData] = useState(null);
  const [branchBoard, setBranchBoard] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  useEffect(() => {
    api.get("/analytics/leaderboard", { params: { branch_id: branchId || undefined, month } }).then((r) => setData(r.data));
  }, [branchId, month]);
  useEffect(() => {
    if (showBranchBoard) api.get("/analytics/branch-leaderboard", { params: { month } }).then((r) => setBranchBoard(r.data)).catch(() => {});
  }, [month, showBranchBoard]);
  const rows = isKec ? (data?.rows || []).slice(0, 5) : (data?.rows || []);

  return (
    <div className="px-4 py-5 lg:px-8 max-w-3xl">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-heading text-2xl font-bold text-[#0E2240]">KEC Leaderboard</h1>
          {isKec && <p className="text-xs text-slate-500 mt-0.5">Top 5 KECs in your branch this month</p>}
        </div>
        <div className="flex gap-2">
          <input data-testid="leaderboard-month-input" type="month" value={month} onChange={(e) => setMonth(e.target.value)}
            className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm" />
          {!isKec && <BranchPicker value={branchId} onChange={setBranchId} />}
        </div>
      </div>

      {showBranchBoard && (
        <div data-testid="branch-leaderboard" className="mt-4 rounded-xl border border-slate-200 bg-white p-4">
          <h2 className="flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-widest text-slate-400"><Building2 size={13} /> Top 5 Branches — test drives</h2>
          <div className="mt-2 space-y-1.5">
            {(branchBoard?.rows || []).length === 0 && <div className="text-xs text-slate-400 py-3 text-center">No closed test drives this month</div>}
            {(branchBoard?.rows || []).map((r, i) => (
              <div key={r.branch} data-testid={`branch-leaderboard-row-${i}`} className="flex items-center gap-3 rounded-lg bg-slate-50 p-2.5">
                <div className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-heading font-bold ${i === 0 ? "bg-[#BF9B30] text-white" : "bg-[#0E2240] text-white"}`}>{i + 1}</div>
                <div className="flex-1 text-sm font-semibold text-[#0E2240]">{r.branch}</div>
                <div className="font-heading text-lg font-bold text-[#BB162B]">{r.tds}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-4 space-y-2">
        {rows.length === 0 && <div className="rounded-xl border border-dashed border-slate-200 p-8 text-center text-sm text-slate-400">No closed test drives this month</div>}
        {rows.map((r, i) => (
          <div key={i} data-testid={`leaderboard-row-${i}`} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3.5">
            <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-heading font-bold ${i === 0 ? "bg-[#BF9B30] text-white" : i < 3 ? "bg-[#0E2240] text-white" : "bg-slate-100 text-slate-500"}`}>
              {i === 0 ? <Trophy size={16} /> : i + 1}
            </div>
            <div className="flex-1">
              <div className="font-bold text-[#0E2240] text-sm">{r.kec_name}</div>
              <div className="text-[11px] text-slate-400">{r.showroom} showroom · {r.home} home · {r.km.toLocaleString("en-IN")} km</div>
            </div>
            <div className="font-heading text-xl font-bold text-[#BB162B]">{r.total}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
